/**
 * Maps USEF API Message values to translation keys
 */
export const messageTranslationMap = {
  "INVALID COMPETITION": "results.upload.errors.invalidCompetition",
  "NOT APPROVED OR ENDORSED": "results.upload.errors.notApproved",
  "FUTURE COMPETITION": "results.upload.errors.futureCompetition",
  "APPROACHING COMPETITION": "results.upload.errors.approachingCompetition",
  "COMPETITION STARTED": "results.upload.errors.competitionStarted",
};

/**
 * Maps USEF API Description values to translation keys
 * Based on the Message, we can provide appropriate descriptions
 */
export const descriptionTranslationMap = {
  "INVALID COMPETITION": "results.upload.descriptions.invalidCompetition",
  "NOT APPROVED OR ENDORSED": "results.upload.descriptions.notApproved",
  "FUTURE COMPETITION": "results.upload.descriptions.futureCompetition",
  "APPROACHING COMPETITION":
    "results.upload.descriptions.approachingCompetition",
  "COMPETITION STARTED": "results.upload.descriptions.competitionStarted",
};

/**
 * Gets the translation key for a given message
 * @param {string} message - The USEF API message
 * @returns {string} Translation key
 */
export function getMessageTranslationKey(message) {
  return messageTranslationMap[message] || "results.upload.errors.unknown";
}

/**
 * Gets the translation key for a given description based on message
 * @param {string} message - The USEF API message
 * @returns {string} Translation key
 */
export function getDescriptionTranslationKey(message) {
  return (
    descriptionTranslationMap[message] || "results.upload.descriptions.unknown"
  );
}
